import { render, staticRenderFns } from "./collectProject.vue?vue&type=template&id=637ab86a&scoped=true&"
import script from "./collectProject.vue?vue&type=script&lang=js&"
export * from "./collectProject.vue?vue&type=script&lang=js&"
import style0 from "./collectProject.vue?vue&type=style&index=0&id=637ab86a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ab86a",
  null
  
)

export default component.exports